import axios from 'axios';
import { PROJECT_API_URL } from 'config';
import { getIdToken } from 'firebaseAPI';

export const configureTerminal = async (
  tid: string,
  accountId: string,
): Promise<any> => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `https://pos.api.vibrant.app/pos/v1/terminals/${tid}/configure_terminal`,
      { accountId },
      {
        headers: { token: idToken },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
